import * as React from "react"
import { Plus, Trash2 } from "lucide-react"
import { Button } from "@ui/Button"
import { Checkbox } from "@ui/Checkbox"
import { Input } from "@ui/Input"
import type { KeyValueEntry } from "@lib/inertia-types"

export function KeyValueEditor({
  entries,
  onChange,
  keyPlaceholder = "Key",
  valuePlaceholder = "Value",
  addLabel = "Add",
}: {
  entries: KeyValueEntry[]
  onChange: (entries: KeyValueEntry[]) => void
  keyPlaceholder?: string
  valuePlaceholder?: string
  addLabel?: string
}) {
  function updateEntry(index: number, patch: Partial<KeyValueEntry>) {
    onChange(entries.map((e, i) => (i === index ? { ...e, ...patch } : e)))
  }

  function removeEntry(index: number) {
    onChange(entries.filter((_, i) => i !== index))
  }

  function addEntry() {
    onChange([...entries, { key: "", value: "", enabled: true }])
  }

  return (
    <div className="flex flex-col gap-1.5">
      {entries.map((entry, i) => (
        <div key={i} className="flex items-center gap-2">
          <Checkbox
            checked={entry.enabled}
            onCheckedChange={(checked) => updateEntry(i, { enabled: checked === true })}
            aria-label="Enabled"
          />
          <Input
            size="sm"
            value={entry.key}
            onChange={(e) => updateEntry(i, { key: e.target.value })}
            placeholder={keyPlaceholder}
            className="flex-1 font-mono"
          />
          <Input
            size="sm"
            value={entry.value}
            onChange={(e) => updateEntry(i, { value: e.target.value })}
            placeholder={valuePlaceholder}
            className="flex-[2] font-mono"
          />
          <Button
            variant="ghost"
            size="iconXs"
            onClick={() => removeEntry(i)}
            aria-label="Remove row"
          >
            <Trash2 className="size-3.5" aria-hidden="true" />
          </Button>
        </div>
      ))}
      <div>
        <Button variant="ghost" size="xs" onClick={addEntry}>
          <Plus className="size-3.5" aria-hidden="true" />
          {addLabel}
        </Button>
      </div>
    </div>
  )
}
